import { MouseEvent, ReactNode, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router';
import clsx from 'clsx';
import { ChevronDownIcon, ChevronRightIcon, TSvgIcon } from '@/components/icons';

export const NavItem = ({
  name,
  Icon,
  href,
  children,
  end,
  badge,
  expandable,
}: {
  name: string;
  Icon?: TSvgIcon;
  href: string;
  children?: ReactNode;
  end?: boolean;
  badge?: ReactNode;
  expandable?: boolean;
}) => {
  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState<boolean>(true);
  const [hasToggled, setHasToggled] = useState<boolean>(false);

  useEffect(() => {
    if (expandable && isDescendantRouteActive() && !hasToggled) {
      setIsExpanded(true);
    }
  }, [location.pathname, expandable, hasToggled, href]);

  const handleToggle = (e: MouseEvent) => {
    if (expandable && children) {
      e.preventDefault();
      e.stopPropagation();
      setIsExpanded((prev) => !prev);
      setHasToggled(true);
    }
  };

  const isDescendantRouteActive = () =>
    location.pathname !== href &&
    location.pathname.startsWith(href) &&
    href !== '#';

  const shouldShowChildren = expandable ? isExpanded : false;

  const ChevronIcon = isExpanded ? ChevronDownIcon : ChevronRightIcon;

  return (
    <div>
      <NavLink to={href} end={end}>
        {({ isActive }) => {
          return (
            <>
              <div
                className={clsx(
                  isActive &&
                    href !== '#' &&
                    'sami-body-bold text-gray-900 bg-gray-50',
                  'text-gray-500 relative group w-full flex items-center px-3 py-2 text-left rounded-md tertiary hover:bg-gray-50',
                )}
              >
                <div className="h-3.5 w-3.5 mr-2">
                  {Icon && (
                    <Icon className="h-full w-full" aria-hidden="true" />
                  )}
                </div>
                <div className="flex-1 flex items-center gap-1">
                  <span>{name}</span>
                  {badge}
                </div>
                {expandable && children && (
                  <div className="h-3.5 w-3.5 ml-2" onClick={handleToggle}>
                    <ChevronIcon className="h-full w-full" aria-hidden="true" />
                  </div>
                )}
              </div>
            </>
          );
        }}
      </NavLink>

      {shouldShowChildren && <div>{children}</div>}
    </div>
  );
};
